import React from "react";

import { Link } from "@material-ui/core";

import { SaaSDestination } from "../../../destinations/destinations";

export function getExtraStepsToReplaceWithFreshpaintVideoProxy(
  trackerName: string
): any[][] {
  const setupVideoProxyCTA = [
    <Link
      key="replace-with-video-proxy-0"
      onClick={() => window.open("https://support.freshpaint.io/")}
    >
      Contact Freshpaint
    </Link>,
    <React.Fragment key="replace-with-video-proxy-1">
      {` to get instructions on how to set up the video proxy for ${trackerName}`}
    </React.Fragment>,
    <ul
      key="replace-with-video-proxy-2"
      style={{ paddingLeft: "30px", listStyle: "disc" }}
    >
      <li>
        You may need to contact your IT team in order to implement the changes.
      </li>
      <li>
        After the changes have been implemented, check the box below to confirm
        your video proxy setup.
      </li>
    </ul>,
  ];
  return [setupVideoProxyCTA];
}

export function getExtraStepsToSetUpFreshpaintMaps(
  trackerName: string
): any[][] {
  const setupFPMapsCTA = [
    <Link
      key="replace-with-freshpaint-maps-0"
      onClick={() => window.open("https://support.freshpaint.io/")}
    >
      Contact Freshpaint
    </Link>,
    /* gitleaks:allow */ <React.Fragment key="replace-with-freshpaint-maps-1">
      {` to get instructions on how to set up Freshpaint maps to replace ${trackerName}`}
    </React.Fragment>,
    <ul
      key="replace-with-freshpaint-maps-2" // gitleaks:allow
      style={{
        paddingLeft: "30px",
        listStyle: "disc",
      }}
    >
      <li>
        You may need to contact your IT team in order to implement the changes.
      </li>
      <li>
        After the changes have been implemented, check the box below to confirm
        your Freshpaint maps setup.
      </li>
    </ul>,
  ];
  return [setupFPMapsCTA];
}

export function getExtraStepsToReplaceWithFreshpaintDestination(
  destination: SaaSDestination
): any[][] {
  let docsURLElement: JSX.Element | null = null;
  if (destination.docsURL !== null) {
    // Typescript needs this declared as a separate variable in order to know
    // that it's not null
    const docsURL = destination.docsURL;
    docsURLElement = (
      <li>
        Read our{" "}
        <Link onClick={() => window.open(docsURL)}>
          guide for setting up {destination.key}
        </Link>
      </li>
    );
  }

  const setupDestinationCTA = [
    <React.Fragment key="set-up-destination-0">{`Visit the `}</React.Fragment>,
    <Link
      key="set-up-destination-1"
      onClick={() => window.open(destination.configPageUrl())}
    >
      destination&apos;s setup page{" "}
    </Link>,
    <React.Fragment key="set-up-destination-2">
      {`to set up the ${destination.key} HIPAA-compliant Freshpaint integration`}
    </React.Fragment>,
    <ul
      key="set-up-destination-3"
      style={{ listStyle: "disc", paddingLeft: "30px" }}
    >
      {docsURLElement}
      <li>
        Having trouble?{" "}
        <Link onClick={() => window.open("https://support.freshpaint.io/")}>
          Contact Freshpaint Support
        </Link>
      </li>
    </ul>,
  ];

  const setupHIPAAAllowlistCTA = [
    <React.Fragment key="set-up-hipaa-allowlist-0">
      Configure the{" "}
    </React.Fragment>,
    <Link
      key="set-up-hipaa-allowlist-1"
      onClick={() => window.open(destination.allowlistUrl())}
    >
      HIPAA Allowlist{" "}
    </Link>,
    <React.Fragment key="set-up-hipaa-allowlist-2">
      to disallow sending PHI to {destination.key}.
    </React.Fragment>,
  ];

  return [setupDestinationCTA, setupHIPAAAllowlistCTA];
}

export function getExtraStepsToUninstallTracker(trackerName: string) {
  return [
    [
      <React.Fragment key="uninstall-tracker-0">
        {`Remove ${trackerName} from your site. `}
      </React.Fragment>,
      <ul
        key="uninstall-tracker-1"
        style={{ paddingLeft: "30px", listStyle: "disc" }}
      >
        <li>
          Depending on how the tracker was installed, you may need to locate the
          tracker in your tag manager, or your IT team may need to make changes
          to your site&apos;s code to remove the tracker.
        </li>
        <li>
          Download the Web Tracker .xlsx Report to identify the pages on your
          site where the tracker is installed.
        </li>
      </ul>,
    ],
  ];
}
